export enum AnnouncementActionEnum {
  CREATE = 1,
  UPDATE = 2,
  ADD_USER = 3,
  ADD_USER_UPDATE = 4
}
